import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { DropdownMenuPrimitive } from '#pplx/frontend/aether/primitives/DropdownMenuPrimitive/index.js';
import { useId } from 'react';
export function MenuGroup({ label, children }) {
    const { isMobileStyle } = useAetherContext();
    const labelId = useId();
    // Mobile renders within a dialog (i.e: bottom sheet) so
    // we render as a plain div group instead of the Radix Group
    if (isMobileStyle) {
        return (_jsxs("div", { role: "group", "aria-labelledby": labelId, children: [_jsx("div", { id: labelId, className: "text-tertiary p-2 text-xs", children: label }), _jsx("div", { children: children })] }));
    }
    return (_jsxs(DropdownMenuPrimitive.Group, { children: [_jsx(DropdownMenuPrimitive.Label, { className: "text-tertiary p-2 text-xs", children: label }), children] }));
}
//# sourceMappingURL=MenuGroup.js.map